// extracted by mini-css-extract-plugin
export default {"appsidebar":"styles_appsidebar__FqEAp","discoverBox":"styles_discoverBox__7J3Zr"};